import { NessoLogo } from '@nesso/ui/icons/nesso-logo';
import { Button } from '@nesso/ui/primitives/button';

import { useAuth } from '@/entities/user';
export function OnboardingHeader() {
    const { signOut } = useAuth();

    return (
        <div className="flex justify-between items-center p-4">
            <NessoLogo />
            <Button variant="ghost" onClick={signOut}>
                Log out
            </Button>
        </div>
    );
}
